import { render, staticRenderFns } from "./ImageGalleryDialog.vue?vue&type=template&id=6c2103ef&scoped=true&lang=pug&"
import script from "./ImageGalleryDialog.vue?vue&type=script&lang=ts&"
export * from "./ImageGalleryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGalleryDialog.vue?vue&type=style&index=0&id=6c2103ef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2103ef",
  null
  
)

export default component.exports